module.exports = __webpack_public_path__ + "static/media/IMG_8731 (2).c09abbd1.jpg";